export default {
    props: {
        borderColor: {
            type: String,
            default: undefined,
            kComposite: 'border.color'
        },
        borderDashType: {
            type: String,
            default: undefined,
            kComposite: 'border.dashType'
        },
        borderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'border.width'
        },
        color: {
            type: String,
            default: undefined,
            kComposite: 'color'
        },
        margin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'margin'
        },
        opacity: {
            type: Number,
            default: undefined,
            kComposite: 'opacity'
        },
        shape: {
            type: String,
            default: undefined,
            kComposite: 'shape'
        },
        size: {
            type: Number,
            default: undefined,
            kComposite: 'size'
        },
        trackBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'track.border.color'
        },
        trackBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'track.border.dashType'
        },
        trackBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'track.border.width'
        },
        trackColor: {
            type: String,
            default: undefined,
            kComposite: 'track.color'
        },
        trackOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'track.opacity'
        },
        trackSize: {
            type: Number,
            default: undefined,
            kComposite: 'track.size'
        },
        trackVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'track.visible'
        },
        value: {
            type: Number,
            default: undefined,
            kComposite: 'value'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gauges-vue-wrapper/src/KendoLinearGauge/PointerProps.js